module.exports = __webpack_public_path__ + "img/Qrcode2.adf30764.png";